// Остаток бесплатного тира и цена (GET /chat/model-pricing) для выбранной модели и настроек — тот же запрос, что
// делал FreeTierBadge сам; вынесен в хук, чтобы предохранитель по балансу (useCreditsGuard) знал о бесплатных
// генерациях: сервер (is_request_free) спишет 0, пока остаток есть, и блокировать кнопку нельзя.
import { useEffect, useState } from 'react'
import { getModelPricing, type FreeTierParams, type ModelPricing } from '../api/chat'

export function useModelPricing(provider: string | null | undefined, model: string | null | undefined,
	type: 'chat' | 'image' | 'video' | null | undefined, params: FreeTierParams | null | undefined,
	refreshKey?: unknown, enabled = true): ModelPricing | null {
	const [info, setInfo] = useState<ModelPricing | null>(null)
	const paramsSig = JSON.stringify(params ?? {})
	useEffect(() => {
		if (!enabled || !provider || !model || !type) { setInfo(null); return }
		let alive = true
		getModelPricing(provider, model, type, params).then((r) => { if (alive) setInfo(r) })
		return () => { alive = false }
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [enabled, provider, model, type, paramsSig, refreshKey])
	return info
}

/** Бесплатные генерации ещё есть — списания не будет, предпроверку по балансу пропускаем. */
export function hasFreeLeft(info: ModelPricing | null | undefined): boolean {
	return !!info?.has_free && (info.free_remaining ?? 0) > 0
}
